
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  display:block;
}

.info-card-wrapper{
  display:flex;
  flex-direction:column;
  gap:3rem;
}

@media (max-width: 768px){
  idb-card-grid{
    padding:0;
  }
  h2{
    margin-top:0;
  }
}`;